/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_Mock_3_DetailInputs */

const en_cap_agents_mock_3_detail = /** @type {(inputs: Cap_Agents_Mock_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checks every claim`)
};

const lv_cap_agents_mock_3_detail = /** @type {(inputs: Cap_Agents_Mock_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbauda katru apgalvojumu`)
};

/**
* | output |
* | --- |
* | "Checks every claim" |
*
* @param {Cap_Agents_Mock_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_mock_3_detail = /** @type {((inputs?: Cap_Agents_Mock_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_Mock_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_mock_3_detail(inputs)
	return en_cap_agents_mock_3_detail(inputs)
});